import { getSiblings, breakpoint } from '../../util/helpers';
import RangeTouch from '../../util/rangetouch';

export default {
  init() {
    const tables = document.querySelectorAll('.ms-conversion-table');

    if (!tables.length) {
      return;
    }

    this.startListener(tables);
  },
  enabledTouch() {
    return 'ontouchstart' in document.documentElement;
  },
  startListener(tables) {
    const selector = {
      scroller: '.ms-conversion-table__scroller',
      scrollerControl: '.ms-conversion-table__scroller-control',
      scrollerTrack: '.ms-conversion-table__scroller-track',
      table: '.ms-conversion-table__table',
      tableInner: '.ms-conversion-table__table-inner',
    }

    let offset;
    let scrollAllowance;
    let lastPosition;

    const setOffset = () => {
      if (breakpoint() === 'mobile') {
        return offset = 16 * 2;
      } else if (breakpoint() === 'tablet') {
        return offset = 33 * 2 - 40;
      } else if (breakpoint() === 'desktop') {
        return offset = 80;
      }
    }

    const setScrollAllowance = () => {
      // column width + gutter width
      if (breakpoint() === 'mobile') {
        return scrollAllowance = 16 + 29;
      } else if (breakpoint() === 'tablet') {
        return scrollAllowance = 0;
      } else if (breakpoint() === 'desktop') {
        return scrollAllowance = 0;
      }
    }

    const resetPosition = () => {
      tables.forEach(table => {
        table.querySelector(selector.scrollerControl).removeAttribute('style');
        table.querySelector(selector.table).removeAttribute('style');
      });
    }

    const handleScrollerDisplay = () => {
      tables.forEach(tableElement => {
        const table = tableElement.querySelector(selector.table);
        const scrollerTrack = tableElement.querySelector(selector.scrollerTrack);
        const parent = table.parentElement;
        const trackLimit = (table.offsetWidth - offset) - parent.offsetWidth;

        if (!scrollerTrack) return;
        if (trackLimit <= -50) {
          scrollerTrack.classList.add('hidden');
        } else {
          scrollerTrack.classList.remove('hidden');
        }
      });
    }

    const scrub = event => {
      const { target } = event;
      const { value, parentElement } = target;

      getSiblings(target).forEach(sibling => {
        const parent = sibling.parentElement;
        const trackLimit = parent.offsetWidth - sibling.offsetWidth;
        sibling.style.left = `${(trackLimit / 100) * value}px`;
      });

      getSiblings(parentElement).forEach(sibling => {
        if (sibling.classList.contains('ms-conversion-table__table-container')) {
          const table = sibling.querySelector(selector.table);
          const parent = sibling.parentElement;
          const trackLimit = (table.offsetWidth - offset) - parent.offsetWidth;
          const finalValue = (trackLimit / 100) * value + ((trackLimit / 100) * value <= 60 && breakpoint() === 'mobile' ? (trackLimit / 100) * value : scrollAllowance);
          table.style.transform = `translateX(-${finalValue}px)`;
        }
      });
    };

    let dragSubscription = () => {}
    const removeDragSubscription = () => {
      dragSubscription();
      dragSubscription = () => {};
    };
    const drag = () => {
      const range = document.querySelector(selector.scroller);
      const rangeParent = range.parentElement;

      if (rangeParent.classList.contains('hidden')) return; // prevent touch event if no scroll tracker
      getSiblings(rangeParent).forEach(sibling => {
        if (sibling.classList.contains('ms-conversion-table__table-container')) {
          const table = sibling.querySelector(selector.table);
          const btn = document.querySelector(selector.scrollerControl);
          const input = document.querySelector(selector.scrollerTrack);
          const parent = sibling.parentElement;

          const trackLimitScroll = input.offsetWidth - btn.offsetWidth;
          const trackLimitTable = (table.offsetWidth - offset) - parent.offsetWidth;

          let mousedown = false;
          let startX = 0;
          let scrollLeft;

          if (this.enabledTouch()) {
            const touchstart = (e) => {
              mousedown = true;
              table.classList.add('grabbing');
              startX = e.changedTouches[0].pageX;
              scrollLeft = table.scrollLeft;
            };
            const touchend = () => {
              mousedown = false;
              table.classList.remove('grabbing');
              // set this current position as the starting point the next time the user scrolls
              lastPosition = range.value;
            };
            const touchmove = (e) => {
              if(!mousedown) return;

              e.preventDefault();
              const x = e.changedTouches[0].pageX - table.offsetLeft;
              const walk = x - startX;
              const rangeValue = lastPosition ? (lastPosition - walk) : (scrollLeft - walk) / 2;
              range.value = rangeValue;

              const finalValueTable = ((trackLimitTable / 100) * range.value) + ((((trackLimitTable / 100) * range.value) <= 55 && breakpoint() === 'mobile') ? ((trackLimitTable / 100) * range.value) : scrollAllowance);
              const finalValueScroller = (trackLimitScroll / 100) * range.value;

              btn.style.left = `${finalValueScroller}px`;
              table.style.transform = `translateX(-${finalValueTable}px)`;
            };
            // mobile touch events
            table.addEventListener('touchstart', touchstart);

            ['touchleave', 'touchend'].forEach(type => {
              table.addEventListener(type, touchend);
            });

            table.addEventListener('touchmove', touchmove);

            dragSubscription = () => {
              table.removeEventListener('touchstart', touchstart);

            ['touchleave', 'touchend'].forEach(type => {
              table.removeEventListener(type, touchend);
            });

            table.removeEventListener('touchmove', touchmove);
            }
          } else {
            // Desktop drag events
            const mousedownListener = (e) => {
              mousedown = true;
              table.classList.add('grabbing');
              startX = e.pageX - table.offsetLeft;
              scrollLeft = table.scrollLeft;
            };
            const mouseleave = () => {
              mousedown = false;
              table.classList.remove('grabbing');
              // set this current position as the starting point the next time the user scrolls
              lastPosition = range.value;
            };
            const mousemove = (e) => {
              if(!mousedown) return;

              e.preventDefault();
              const x = e.pageX - table.offsetLeft;
              const walk = x - startX;
              const rangeValue = lastPosition ? (lastPosition - walk) : (scrollLeft - walk) / 2;
              range.value = rangeValue;

              const finalValueTable = ((trackLimitTable / 100) * range.value) + ((((trackLimitTable / 100) * range.value) <= 55 && breakpoint() === 'mobile') ? ((trackLimitTable / 100) * range.value) : scrollAllowance);
              const finalValueScroller = (trackLimitScroll / 100) * range.value;

              btn.style.left = `${finalValueScroller}px`;
              table.style.transform = `translateX(-${finalValueTable}px)`;
            };
            table.addEventListener('mousedown', mousedownListener);

            ['mouseleave', 'mouseup'].forEach(type => {
              table.addEventListener(type, mouseleave);
            });

            table.addEventListener('mousemove', mousemove);

            dragSubscription = () => {
              table.removeEventListener('mousedown', mousedownListener);

            ['mouseleave', 'mouseup'].forEach(type => {
              table.removeEventListener(type, mouseleave);
            });

            table.removeEventListener('mousemove', mousemove);
            }
          }
        }
      });
    }

    tables.forEach(table => {
      const range = new RangeTouch(table.querySelector(selector.scroller));
      const scrollerTrack = table.querySelector(selector.scrollerTrack);
      const tableInner = table.querySelector(selector.tableInner)

      if (parseInt(table.offsetWidth) < parseInt(tableInner.offsetWidth)) {
        scrollerTrack.remove();
      }

      range.element.oninput = event => scrub(event);
    });

    window.addEventListener('load', () => {
      setOffset();
      setScrollAllowance();
      handleScrollerDisplay();
      removeDragSubscription();
      drag();
    });

    window.addEventListener('resize', () => {
      resetPosition();
      setOffset();
      setScrollAllowance();
      removeDragSubscription();
      drag();
      handleScrollerDisplay();
    });
  },
};



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/conversion-table.js